<template>
  <div class="mipe-calendar-column col">
    <header :class="{ 'has-error': day.hasError }">
      <em v-if="day.hasError" class="far fa-exclamation-circle" />
      <span>{{ day.name | capitalize }}</span>
      <h3>{{ day.dayNumber }}</h3>
      <label v-if="day.hasError" class="error">{{ day.errorMsg }}</label>
    </header>

    <div
      :class="{ 'show-more': hasPreviousSchedule }"
      class="footer text-center"
      @click="
        () => {
          this.showPrevious();
        }
      "
    >
      <em
        v-if="hasPreviousSchedule"
        style="position:relative;bottom:3px"
        class="fa fa-angle-double-up"
      />
    </div>

    <section class="text-center">
      <div v-if="isScheduleEmpty" class="no-available">
        <span>No Disponible</span>
      </div>
      <ScheduleItem
        v-for="schedule in schedules"
        :key="schedule.id"
        :item="schedule"
        @select-schedule="
          $emit('select-schedule', {
            scheduleId: schedule.id,
            date: day.date,
            hasError: day.hasError,
            isSelected: schedule.isSelected,
          })
        "
      />
    </section>

    <div
      :class="{ 'show-more': hasNextSchedules }"
      class="footer text-center"
      @click="
        () => {
          this.showNext();
        }
      "
    >
      <em v-if="hasNextSchedules" class="fa fa-angle-double-down" />
    </div>
  </div>
</template>

<script>
import ScheduleItem from './WeekCalendarScheduleItem';

export default {
  meta: {
    description: 'Componente común, columnas en el calendario semanal.',
    slots: {
      default: {
        type: 'component',
        valid: [],
      },
    },
  },
  props: {
    day: {
      type: Object,
      default: () => {
        return {};
      },
      meta: {
        description: 'Propiedad para los días del calendario',
        example: '{ key1: value1, key2: value2 }',
      },
    },
  },
  data() {
    return {
      schedules: [],
      nextRemaining: [],
      previousRemaining: [],
    };
  },
  mounted() {
    this.schedules = this.day.schedules;
    if (this.day.scheduleList.length > 7)
      this.nextRemaining = this.day.scheduleList.slice(7);
  },
  components: {
    ScheduleItem,
  },
  computed: {
    isScheduleEmpty() {
      return this.day.scheduleList.length === 0;
    },
    hasNextSchedules() {
      return this.nextRemaining.length > 0;
    },
    hasPreviousSchedule() {
      return this.previousRemaining.length > 0;
    },
  },
  methods: {
    showNext() {
      if (this.nextRemaining.length === 0) return;

      const addNext = this.nextRemaining.splice(0, 1);
      this.schedules.push(addNext[0]);

      const addToPrevious = this.schedules.splice(0, 1);
      this.previousRemaining.push(addToPrevious[0]);
    },
    showPrevious() {
      if (this.previousRemaining.length === 0) return;

      const addToSchedule = this.previousRemaining.pop();
      this.schedules.splice(0, 0, addToSchedule);

      const addNext = this.schedules.pop();
      this.nextRemaining.push(addNext);
    },
  },
};
</script>

<style scoped>
.mipe-calendar-column header {
  background-color: #f2f2f2;
  height: 131px;
  width: 100%;
  padding: 0.7em 0 0 1.3em;
  border: 1px solid #e2e2e2;
}
.mipe-calendar-column header span {
  color: #ff7058;
  position: relative;
  font-weight: 600;
  font-size: 0.9em;
  top: 0.5em;
}

.mipe-calendar-column header h3 {
  color: #3f5b60;
  font-size: 2.5em;
  font-weight: 900;
  padding-top: 0.1em;
}

.mipe-calendar-column section {
  width: 100%;
  border: 1px solid #e2e2e2;
}
.mipe-calendar-column .footer {
  height: 28px;
  width: 100%;
  background-color: #f2f2f2;
  border-left: 1px solid #e2e2e2;
  border-bottom: 1px solid #e2e2e2;
  border-right: 1px solid #e2e2e2;
}
.mipe-calendar-column .footer.show-more {
  background: #2db782;
  border: none;
}
.mipe-calendar-column .footer.show-more em {
  color: #fff;
  font-size: 2em;
  font-weight: 100;
}
.mipe-calendar-column section .no-available {
  position: absolute;
  border: none;
  top: 55%;
  color: #e2e2e2;
}

.mipe-calendar-column header.has-error,
.mipe-calendar-column header.has-error h3,
.mipe-calendar-column header.has-error span,
.mipe-calendar-column header.has-error em {
  color: #c9545e;
}
.mipe-calendar-column header.has-error label {
  position: absolute;
  top: 90px;
  left: 10px;
  font-size: 0.8em;
  font-weight: 100;
}
.mipe-calendar-column header.has-error em {
  font-size: 2em;
  position: absolute;
  right: 0.5em;
}
</style>
